<template>
  <div v-if="show" class="loading-overlay">
    <div class="loading-spinner">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',

  props: {
    /**
     * Whether to show the loading overlay
     * @type {Boolean}
     */
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>
